import { Link } from "react-router-dom";
import { Button } from "@csa/web-foundation";
import { useT } from "../i18n/index";
import { usePartyPrincipal } from "../auth/party-principal";
import { useActiveProposals } from "../proposal/use-proposal";
import { Icon } from "../ui/icons";

// The authenticated landing — a calm concierge welcome, not a metrics dashboard. The
// display name comes from the masked profile (GET /v1/customer/profile). F1-F: when an
// active proposal exists, a discovery card surfaces it ("Teklifiniz hazır → görüntüle")
// so the customer reaches it from the app, without a nudge/deep-link. A generic advisor
// presence follows (the named advisor is staff PII, deliberately suppressed for the
// party realm — customer.service.ts), keeping the concierge tone without faking data.
export function Home() {
  const { t } = useT();
  const { profile } = usePartyPrincipal();
  const proposals = useActiveProposals();
  const hasActive = (proposals.data?.length ?? 0) > 0;

  return (
    <div className="stack">
      <div className="cx-pagehead">
        <div data-testid="home">
          <h1>
            {t("home.ready")}
            {profile ? `, ${profile.firstName}` : ""}.
          </h1>
          <p className="cx-pagehead__sub">{t("home.concierge")}</p>
        </div>
      </div>

      {hasActive ? (
        <section className="cx-card" data-testid="home-proposal-card">
          <div className="cx-card__head">
            <span className="cx-tile cx-tile--blue" aria-hidden="true">
              <Icon name="suggestion" size={22} />
            </span>
            <div className="cx-card__headmain">
              <span className="cx-card__title">{t("home.proposalReady")}</span>
              <span className="cx-card__sub">{t("home.proposalReadyBody")}</span>
            </div>
          </div>
          <div className="cx-cardcta">
            <Link to="/proposal">
              <Button variant="primary">{t("home.proposalReadyCta")}</Button>
            </Link>
          </div>
        </section>
      ) : null}

      <section className="cx-card" data-testid="home-advisor">
        <div className="cx-advisor">
          <span className="cx-tile cx-tile--green" aria-hidden="true">
            <Icon name="conversation" size={22} />
          </span>
          <div className="cx-card__headmain">
            <span className="cx-card__title">{t("pf.advisorTitle")}</span>
            <span className="cx-card__sub">{t("pf.advisorNote")}</span>
          </div>
          {/* Dalga-1: in-app mesajlaşma yok — sahte "Mesaj gönder" CTA yerine dürüst,
              uca çıkmayan bilgi. Mesajlaşma yüzeyi geldiğinde CTA burada geri döner. */}
          <div className="cx-advisor__actions">
            <span className="cx-card__sub" data-testid="home-advisor-reach">
              {t("pf.advisorReach")}
            </span>
          </div>
        </div>
      </section>
    </div>
  );
}
